
import React from 'react'
import { connect } from 'react-redux'

import { setUser, setSignin, setRoute, setToken, setAdminToken, setAdminUsername } from '../../actions/user-action'

import {Helmet} from 'react-helmet';

import { setWebsite } from '../../actions/website-action'

import {Grid, Row, Col, Button, FormControl} from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { store } from '../../store';

import LoadingBar from 'react-redux-loading-bar'

import Rolling from '../../Images/rolling.svg';

const mapStateToProps = (state) => {
  let user = state.user.user;
  let isSignedIn = state.user.isSignedIn;
  let website = state.website;
  let route = state.user.route;
  let admin = state.admin
  return {
    user: user,
    website: website,
    isSignedIn: isSignedIn,
    route: route,
    admin: admin
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUser: (user) => dispatch(setUser(user)),
    onSignin: (signin) => dispatch(setSignin(signin)),
    onWebsite: (website) => dispatch(setWebsite(website)),
    onRouteChange: (route) => dispatch(setRoute(route)),
    onAdminToken: (token) => dispatch(setAdminToken(token)),
    onAdminUsername: (username) => dispatch(setAdminUsername(username)),
}
}

class Signin extends React.Component {
	constructor() {
		super()
		this.state = {
			adminUsername: '',
			userUsername: '',
			password: '',
			token: '',
			status: '',
			error: '',
			tokenValid: false
		}
	}
	render() {
		console.log(this.state)
let { onRouteChange, onUser, onWebsite, onSignin, onToken, onAdminToken, onAdminUsername } = this.props
const _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onButton()
    }
  }
const signinSuccess = (signin, user, website, route) =>  {
	this.setState({status: 'processing'})
	fetch(`${process.env.REACT_APP_API}/signin`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
      admin: {
      	username: this.state.adminUsername,
      	password: this.state.password
      },
      user: {
      	username: this.state.userUsername
      },
      token: this.state.token
    })
    })
      .then(response => {
      	response.json()
      	.then(signin => {
        if (signin.auth) {
          	onAdminUsername(this.state.adminUsername)
			onAdminToken(this.state.token)
          	onUser(signin.user)
          	onWebsite(signin.website)
          	onSignin('true')
			onRouteChange('dashboard')
			this.setState({status: 'success'})
		}
		else if(signin.user === 'deactivated') {
			this.setState({error: 'deactivated'})
			this.setState({status: ''})
		}
		else if(signin.user === "banned") {
			this.setState({error: 'banned'})
			this.setState({status: ''})
		}
		else {
			this.setState({error: 'error'})
			this.setState({status: ''})
		}
      })
      })
}
const onButton = () => {
	if(!this.state.userUsername || !this.state.adminUsername || !this.state.token || !this.state.password) {
		this.setState({error: 'empty'})
	}
   	else if(this.state.status === '')
   	return signinSuccess()
   	else return null
}
let logmsg = null
if(store.getState().user.isSignedIn)
	return window.location = '/'
if(this.state.status === 'success') {
			setTimeout(
		    function() {
		        this.setState({ status: '' })
		    }
		    .bind(this),
		    2000
			)
			}
	if(this.state.error) {
			setTimeout(
		    function() {
		        this.setState({ status: '' })
		    }
		    .bind(this),
		    800
			)
			}
      return (
      	<div className="form_bg"
	        	onKeyDown={_handleKeyPress}>
	        	<Helmet>
          <meta name="robots" content="noindex, nofollow" />
         </Helmet>
	        <Grid>
	        <Row>
	        <Col>
	        <LoadingBar />
	        </Col>
	        </Row>
	        <Row>
	        <Col lg={6} md={8} sm={10} xs={12} className="form">
	        <Link to={'/'}><span href="#" className="close"/></Link>
	        <h3>Sign in</h3>
	        {this.state.error === 'empty'
            ? <div><div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Enter username & password</span></div></div>
            : null
          	}
          	{this.state.error === 'error'
            ? <div><div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Wrong username or password</span></div></div>
            : null
          	}
          	<br />
	        <FormControl  
	        	className="form_inp"
	        	type="text" 
	        	name="key" 
	        	placeholder="Admin Username" 
	        	onFocus={()=> this.setState({error: ''})}
	        	value={this.state.adminUsername}
	        	onChange={(e)=>this.setState({adminUsername: e.target.value.toLowerCase()})}
	        />
	        <br/>

	        <FormControl  
	        	className="form_inp"
	        	type="text" 
	        	name="key" 
	        	placeholder="User Username" 
	        	onFocus={()=> this.setState({error: ''})}
	        	value={this.state.userUsername}
	        	onChange={(e)=>this.setState({userUsername: e.target.value.toLowerCase()})}
	        />
	        <br/>

	        <FormControl  
	        	className="form_inp"
	        	type="text" 
	        	name="key" 
	        	placeholder="Token" 
	        	onFocus={()=> this.setState({error: ''})}
	        	value={this.state.token}
	        	onChange={(e)=>this.setState({token: e.target.value})}
	        />
	        <br/>

	        <FormControl  
	        	className="form_inp"
	        	type="password" 
	        	name="password" 
	        	placeholder="Password" 
	        	onFocus={()=> this.setState({error: ''})}
	        	value={this.state.password}
	        	onChange={(e)=>{
	        		this.setState({password: e.target.value})
	        	}}
	        />
	        <br /><br />
	        <Button onClick={onButton.bind()} className="top_btn frm">
	        {this.state.status === 'processing'
	      	?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
	      	: null
	 		}
	 		{this.state.status === ''
	      	?<span>Signin</span>
	      	: null
	 		}
	        </Button>
	        <br /><br />
	        <Link to="/create" >Don't have a profile yet? Create one</Link>
	        </Col>
	        </Row>
	        </Grid>

	    </div>
      )
}
}
export default connect(mapStateToProps, mapDispatchToProps)(Signin);